import { Component, OnInit } from "@angular/core";
import { MemberappBaseComponent } from "../memberapp-base/memberapp-base.component";
import { FormGroup, Validators } from "@angular/forms";
import { EducationDetails } from "../../../shared/models";
import { EducationChildComponent } from "../_common";
import { AccountType, MemberType } from "../../../shared/enums/data.enums";

@Component({
  selector: "app-education",
  templateUrl: "./education.component.html",
  styleUrls: ["./education.component.scss"]
})
export class EducationComponent extends MemberappBaseComponent {
  educationForm: FormGroup;
  educationDetails: EducationDetails;
  memberType: MemberType;
  AccountType: typeof AccountType = AccountType;
  MemberType: typeof MemberType = MemberType;
  ui_Speciality: any;
  isInternational: boolean = true;

  //pga: hotfix-5637 make Residency details non-required for EM before 2000
  startEMBefore2000: boolean = false;

  get medicalSchool() {
    return this.educationForm.get("medicalSchool");
  }
  get residency() {
    return this.educationForm.get("residency");
  }
  get fellowship() {
    return this.educationForm.get("fellowship");
  }
  get boardCertification() {
    return this.educationForm.get("boardCertification");
  }
  get attest() {
    return this.educationForm.get("attest");
  }

  get isFormFilled() {
    const m = this.educationDetails?.medicalSchool;
    const r = this.educationDetails?.residency;
    const f = this.educationDetails?.fellowship;

    return !!m?.contactmedicalschoolid || !!r?.contactresidencyid || !!f?.contactfellowshipid;

  }

  ngOnInit() {
    //this.loggerService.logInfo(this.memberAppDataService.memberAppData);

    //reset
    this.resetForm();

    //subscriptions
  }

  ngAfterViewInit() {
    this.memberAppDomService.initEducationStyles();

  }

  resetForm() {
    this.memberType = this.memberAppDataService.memberAppData.membershipDetails.memberType;
    this.startEMBefore2000 = this.memberAppDataService.memberAppData.membershipDetails.startEMBefore2000;
    this.educationDetails = this.memberAppDataService.memberAppData.educationDetails;


    //USA - Specialities
    this.isInternational = this.memberAppDataService.memberAppData.profile.IsInternational;

    if (!this.isInternational) {
      let USA_EM_Specialities = ['EM', 'EMANES', 'EMIM', 'FMEM', 'PEM'];
      this.ui_Speciality = this.commonOpsService.DeepCopyObject(this.dataService.uidata.Speciality.filter(a => USA_EM_Specialities.indexOf(a.acep_code) > -1));

    }
    else {
      this.ui_Speciality = this.commonOpsService.DeepCopyObject(this.dataService.uidata.Speciality);

    }


    this.educationForm = this.fb.group({
      medicalSchool: EducationChildComponent.buildForm_MS(
        this.educationDetails.medicalSchool,
        this.fb,
        this.memberType,
        !!this.educationDetails?.medicalSchool?.contactmedicalschoolid
      ),

      residency: EducationChildComponent.buildForm_R(
        this.educationDetails.residency,
        this.fb,
        this.memberType,
        true, //!this.memberAppDataService.isAGraduatingResident,  MB 7/21/2025 -- Why do we need this
        this.startEMBefore2000,
        !!this.educationDetails?.residency?.contactresidencyid
      ),

      fellowship: EducationChildComponent.buildForm_F(
        this.educationDetails.fellowship,
        this.fb,
        this.memberType,
        true, //!this.memberAppDataService.isAGraduatingFellow,  MB 7/21/2025 -- Why do we need this
        !!this.educationDetails?.fellowship?.contactfellowshipid
      ),

      boardCertification: EducationChildComponent.buildForm_B(
        this.educationDetails.boardCertification,
        this.fb,
        this.memberType
      ),

      attest: [
        false,
        Validators.compose(
          this.memberType == MemberType.Physician
            ? [Validators.requiredTrue]
            : []
        )
      ]
    });

    if (this.memberType == MemberType.Student) {
      this.medicalSchool.markAsDirty({ onlySelf: false });
    } else if (this.memberType == MemberType.Resident) {
      this.residency.markAsDirty({ onlySelf: false });
    } else if (this.memberType == MemberType.Fellow) {
      this.fellowship.markAsDirty({ onlySelf: false });
    }


  }

  save() {
    //disable the address in bc to prevent validation errors
    this.boardCertification.get("address").disable();
    //let c  = this.residency.get('accountLookUp.name')

    super.onSave(this.educationForm);

    if (this.educationForm.valid) {
      // this.educationForm.dirty
      if (
        this.medicalSchool.dirty ||
        this.residency.dirty ||
        this.fellowship.dirty ||
        this.boardCertification.dirty
      ) {
        // Copy the form values over the product object values
        this.educationDetails = this.educationService.prepareDataModel(
          this.educationDetails,
          this.educationForm
        );
        if (
          !this.educationService.validateGradDates(
            this.educationDetails,
            this.memberType
          )
        ) {
          this.globalDomOpsService.notify(
            "Graduation dates are not in chronological order. Please correct it to proceed further.",
            "",
            "error"
          );

          return false;
        }

        this.loggerService.logInfo(this.educationDetails);
        this.educationService
          .saveEducationDetails(this.educationDetails)
          .subscribe(
            (t: any) => {
              this.educationDetails = t;
              this.onSaveComplete(this.educationDetails);
            },
            (error: any) => {
              this.errorMessage = <any>error;
              super.onError();
            }
          );
      } else {
        this.onSaveComplete();
      }
    }
  }

  onSaveComplete(d?: EducationDetails) {
    let thisSvc = this;
    this.memberAppDataService.memberAppData.educationDetails = this.educationDetails;
    this.globalDomOpsService.notify("Education Details Updated");
    let nextRoute = this.memberAppDataService.memberAppData.profile
      .IsInternational
      ? "sections"
      : "chapters";

    if (!!d) {
      //this.memberAppDataService.ResetMemberAppData();
      this.globalDomOpsService.showwait();
      this.memberAppDataService.LoadMembership().subscribe(
        (t: any) => {
          //EMRA Edge Case
          // if (thisSvc.memberAppDataService.isAGraduatingResident || thisSvc.memberAppDataService.isAGraduatingFellow) {
          //   thisSvc.memberAppDataService.memberAppData.membershipDetails.memberType = thisSvc.memberAppDataService.membTypeSavedFromUI;
          // }

          thisSvc.memberAppDataService.memberAppData.membershipDetails.memberType = thisSvc.memberAppDataService.membTypeSavedFromUI;

          thisSvc.memberAppDataService.navigateToRoute(nextRoute);
        },
        (error: any) => {
          thisSvc.errorMessage = <any>error;
          super.onError();
        }
      );
    } else {
      this.memberAppDataService.navigateToRoute(nextRoute);
    }
  }
}
